export const RECEIVE_PRODUCTS = "RECEIVE_PRODUCTS"
export const ADD_TO_CART = "ADD_TO_CART"
export const REMOVE_FROM_CART = "REMOVE_FROM_CART"


export const RESET_CART = "RESET_CART"
export const RECEIVE_CART = "RECEIVE_CART"
export const ADD_TO_USER_CART = "ADD_TO_USER_CART"
export const REMOVE_FROM_USER_CART = "REMOVE_FROM_USER_CART"



export const RECEIVE_BRANCH = "RECEIVE_BRANCH"
